module.exports = __webpack_public_path__ + "fonts/bhicons.47ff1252.woff";